import "./print.scss"

export function PrintTest(props: {

}) {

	return (
		<div className="section">
			<h1>Heading</h1>

			<div className="table-of-contents">
				<h2>Table of contents</h2>

				<ul>
					<li><a href="#chapter-1">Chapter title</a></li>
					<li><a href="#chapter-2">Chapter title 2</a></li>
					<li><a href="#chapter-3">William Coward</a></li>
					<li><a href="#chapter-4">Chamaeleon</a></li>
				</ul>
			</div>

			<div className="blank-page"></div>

			<article>
				<h2>Chapter title</h2>
				<p>The quick brown fox jumps over the lazy dog</p>
			</article>


			<h1>Preliminary</h1>
			<ol>
				<li className="h1">
					EXCLUSION OF REPLACEABLE RULES
					<p>The replaceable rules contained in the Act do not apply to the Company.</p>
				</li>
				<li className="h1">
					DEFINITIONS
					<p>In this Constitution:-</p>
					<p>Person includes:-</p>
					<ol type="a">
						<li>a natural person; and</li>
						<li>a registered company, corporation or incorporated association.</li>
					</ol>
				</li>
				<li>
				</li>
			</ol>


		</div>
	);
}